import { createSlice } from "@reduxjs/toolkit";
import {
  getPayrollList,
  getPayrollDetail,
  getSalaryConfig,
  updateSalaryConfig,
} from "./payrollActions";

const initialState = {
  list: {
    loading: false,
    error: null,
    items: { results: [], meta: {} },
  },
  detail: {
    loading: false,
    error: null,
    data: null,
  },
  config: {
    loading: false,
    saving: false,
    error: null,
    saveSuccess: false,
    data: null,
  },
};

const payrollSlice = createSlice({
  name: "payroll",
  initialState,
  reducers: {
    resetListError: (state) => {
      state.list.error = null;
      state.list.loading = false;
    },
    resetDetailError: (state) => {
      state.detail.error = null;
      state.detail.loading = false;
    },
    resetConfigError: (state, action) => {
      if (action?.payload && state.config.error) {
        delete state.config.error[action.payload];
        if (Object.keys(state.config.error).length === 0) {
          state.config.error = null;
        }
      } else {
        state.config.error = null;
      }
    },
    resetConfigSuccess: (state) => {
      state.config.saveSuccess = false;
    },
    clearConfigData: (state) => {
      state.config.loading = false;
      state.config.saving = false;
      state.config.error = null;
      state.config.saveSuccess = false;
      state.config.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPayrollList.pending, (state) => {
        state.list.loading = true;
        state.list.error = null;
      })
      .addCase(getPayrollList.fulfilled, (state, { payload }) => {
        state.list.items = payload;
        state.list.loading = false;
        state.list.error = null;
      })
      .addCase(getPayrollList.rejected, (state, { payload }) => {
        state.list.loading = false;
        state.list.error = payload;
      })
      .addCase(getPayrollDetail.pending, (state) => {
        state.detail.loading = true;
        state.detail.error = null;
      })
      .addCase(getPayrollDetail.fulfilled, (state, { payload }) => {
        state.detail.data = payload;
        state.detail.loading = false;
        state.detail.error = null;
      })
      .addCase(getPayrollDetail.rejected, (state, { payload }) => {
        state.detail.loading = false;
        state.detail.error = payload;
      })
      .addCase(getSalaryConfig.pending, (state) => {
        state.config.loading = true;
        state.config.error = null;
      })
      .addCase(getSalaryConfig.fulfilled, (state, { payload }) => {
        state.config.loading = false;
        state.config.data = payload;
        state.config.error = null;
      })
      .addCase(getSalaryConfig.rejected, (state, { payload }) => {
        state.config.loading = false;
        state.config.error = payload;
      })
      .addCase(updateSalaryConfig.pending, (state) => {
        state.config.saving = true;
        state.config.error = null;
        state.config.saveSuccess = false;
      })
      .addCase(updateSalaryConfig.fulfilled, (state, { payload }) => {
        state.config.saving = false;
        state.config.data = payload;
        state.config.error = null;
        state.config.saveSuccess = true;
      })
      .addCase(updateSalaryConfig.rejected, (state, { payload }) => {
        state.config.saving = false;
        state.config.error = payload;
      });
  },
});

export const {
  resetListError,
  resetDetailError,
  resetConfigError,
  resetConfigSuccess,
  clearConfigData,
} = payrollSlice.actions;
export default payrollSlice.reducer;
